frappe.provide("frappe.help.help_links");

const lang = frappe.boot.user.language == "fr" ? "/fr/" : "/";
const docsUrl = `https://doc.dokos.io${lang}`;

// @dokos: help links point to doc.dokos.io. Upstream's ERPNext user manual entries do not
// exist there and are dropped on purpose. Do not re-add them when porting upstream PRs.

frappe.help.help_links["Form/Asset"] = [
	{
		label: __("Getting started with assets"),
		url: docsUrl + "assets/getting-started",
	},
];
